const locations = [
{
'SAN JOSE': [
{
    'SAN JOSE': 
    ['El Carmen','Merced','Hospital','Catedral','Zapote','San Fco.de Dos Ríos','Uruca','Mata Redonda','Pavas','Hatillo','San Sebastián']
},
{
    'ESCAZU':
    ['Escazú','San Antonio','San Rafael']
},
{
    'DESAMPARADOS':
    ['Desamparados','San Miguel','San Juan de Dios','San Rafael Arriba','San Antonio','Frailes','Patarrá','San Cristóbal','Rosario','Damas','San Rafael Abajo','Gravilias']
},
{
    'PURISCAL':
    ['Santiago','Mercedes Sur','Barbacoas','Grifo Alto','San Rafael','Candelarita','Desamparaditos','San Antonio','Chires']
},
{
    'TARRAZU':
    ['San Marcos','San Lorenzo','San Carlos']
},
{
    'ASERRI':
    ['Aserrí','Tarbaca','Vuelta de Jorco','San Gabriel','Legua','Monterrey','Salitrillos']
},
{
    'MORA':
    ['Colón','Guayabo','Tabarcia','Piedras Negras','Picagres']
},
{
    'GOICOECHEA':
    ['Guadalupe','San Francisco','Calle Blancos','Mata de Plátano','Ipís','Rancho Redondo','Purral']
},
{
    'SANTA ANA':
    ['Santa Ana','Salitral','Pozos','Uruca','Piedades','Brasil']
},
{
    'ALAJUELITA':
    ['Alajuelita','San Josecito','San Antonio','Concepción','San Felipe']
},
{
    'VASQUEZ DE CORONADO':
    ['San Isidro','San Rafael','Dulce Nombre de Jesús','Patalillo','Cascajal']
},
{
    'ACOSTA':
    ['San Ignacio','Guaitíl','Palmichal','Cangrejal','Sabanillas']
},
{
    'TIBAS':
    ['San Juan','Cinco Esquinas','Anselmo Llorente','León XIII','Colima']
},
{
    'MORAVIA':
    ['San Vicente','San Jerónimo','Trinidad']
},
{
    'MONTES DE OCA':
    ['San Pedro','Sabanilla','Mercedes','San Rafael']
},
{
    'TURRUBARES':
    ['San Pablo','San Pedro','San Juan de Mata','San Luis']
},
{
    'DOTA':
    ['Santa María','Jardín','Copey']
},
{
    'CURRIDABAT':
    ['Curridabat','Granadilla','Sánchez','Tirrases']
},
{
    'PEREZ ZELEDON':
    ['San Isidro de El General','General','Daniel Flores','Rivas','San Pedro','Platanares','Pejibaye','Cajón','Barú','Río Nuevo','Páramo']
},
{
    'LEON CORTES':
    ['San Pablo','San Andrés','Llano Bonito','San Isidro','Santa Cruz','San Antonio']
}
]},
{
'ALAJUELA':
[
{
    'ALAJUELA':
    ['Alajuela','San José','Carrizal','San Antonio','Guácima','San Isidro','Sabanilla','San Rafael','Río Segundo','Desamparados','Turrúcares','Tambor','La Garita','Sarapiquí']
},
{
    'SAN RAMON':
    ['San Ramón','Santiago','San Juan','Piedades Norte','Piedades Sur','San Rafael','San Isidro','Angeles','Alfaro','Volio','Concepción','Zapotal','Peñas Blancas']
},
{
    'GRECIA':
    ['Grecia','San Isidro','San José','San Roque','Tacares','Río Cuarto','Puente de Piedra','Bolívar']
},
{
    'SAN MATEO':
    ['San Mateo','Desmonte','Jesús María']
},
{
    'ATENAS':
    ['Atenas','Jesús','Mercedes','San Isidro','Concepción','San José','Santa Eulalia']
},
{
    'NARANJO':
    ['Naranjo','San Miguel','San José','Cirrí Sur','San Jerónimo','San Juan','Rosario']
},
{
    'PALMARES':
    ['Palmares','Zaragoza','Buenos Aires','Santiago','Candelaria','Esquipulas','Granja']
},
{
    'POAS':
    ['San Pedro','San Juan','San Rafael','Carrillos','Sabana Redonda']
},
{
    'OROTINA':
    ['Orotina','Mastate','Hacienda Vieja','Coyolar','Ceiba']
},
{
    'SAN CARLOS':
    ['Quesada','Florencia','Buenavista','Aguas Zarcas','Venecia','Pital','Fortuna','Tigra','Palmera','Venado','Cutris','Monterrey','Pocosol']
},
{
    'ALFARO RUIZ':
    ['Zarcero','Laguna','Tapezco','Guadalupe','Palmira','Zapote','Brisas']
},
{
    'VALVERDE VEGA':
    ['Sarchí Norte','Sarchí Sur','Toro Amarillo','San Pedro','Rodríguez']
},
{
    'UPALA':
    ['Upala','Aguas Claras','San José o Pizote','Bijagua','Delicias','Dos Ríos','Yolillal']
},
{
    'LOS CHILES':
    ['Los Chiles','Caño Negro','El Amparo','San Jorge']
},
{
    'GUATUSO':
    ['San Rafael','Buenavista','Cote']
}
]},
{
'CARTAGO':
[
    {'CARTAGO':
    ['Oriental','Occidental','Carmen','San Nicolás','Aguacaliente  o  San Fco.','Guadalupe o Arenilla','Corralillo','Tierra Blanca','Dulce Nombre','Llano Grande','Quebradilla']
},
{
    'PARAISO':
    ['Paraíso','Santiago','Orosi','Cachí']
},
{
    'LA UNION':
    ['Tres Ríos','San Diego','San Juan','San Rafael','Concepción','Dulce Nombre','San Ramón','Río Azul','JIMENEZ','Juan Viñas','Tucurrique','Pejibaye']
},
{
    'TURRIALBA':
    ['Turrialba','La Suiza','Peralta','Santa Cruz','Santa Teresita','Pavones','Tuis','Tayutic','Santa Rosa','Tres Equis']
},
{
    'ALVARADO':
    ['Pacayas','Cervantes','Capellades']
},
{
    'OREAMUNO':
    ['San Rafael','Cot','Potrero Cerrado','Cipreses','Santa Rosa']
},
{
    'EL GUARCO':
    ['El Tejar','San Isidro','Tobosi','Patio de Agua']
}]},
{
'HEREDIA':
[
{
    'HEREDIA':
    ['Heredia','Mercedes','San Francisco','Ulloa','Vara Blanca']
},
{
    'BARVA':
    ['Barva','San Pedro','San Pablo','San Roque','Santa Lucía','San José de La Montaña']
},
{
    'SANTO DOMINGO':
    ['Santo Domingo','San Vicente','San Miguel','Paracito','Santo Tomás','Santa Rosa','Tures','Pará']
},
{
    'SANTA BARBARA':
    ['Santa Bárbara','San Pedro','San Juan','Jesús','Santo Domingo','Purabá']
},
{
    'SAN RAFAEL':
    ['San Rafael','San Josecito','Santiago','Angeles','Concepción']
},
{
    'SAN ISIDRO':
    ['San Isidro','San José','Concepción','San Francisco']
},
{
    'BELEN':
    ['San Antonio','Rivera','Asunción']
},
{
    'FLORES':
    ['San Joaquín','Barrantes','Llorente']
},
{
    'SAN PABLO': ['San Pablo']
},
{
    'SARAPIQUI':
    ['Puerto Viejo','La Vírgen','Horquetas','Llanuras del Gaspar','Cureña']
}]},
{
'GUANACASTE':
[
{
    'LIBERIA':
    ['Liberia','Cañas Dulces','Mayorga','Nacascolo','Curubandé']
},
{
    'NICOYA':
    ['Nicoya','Mansión','San Antonio','Quebrada Honda','Sámara','Nosara','Belén de Nosarita']
},
{
    'SANTA CRUZ':
    ['Santa Cruz','Bolsón','27 de Abril','Tempate','Cartagena','Cuajiniquil','Diriá','Cabo Velas','Tamarindo']
},
{
    'BAGACES':
    ['Bagaces','Fortuna','Mogote','Río Naranjo']
},
{
    'CARRILLO':
    ['Filadelfia','Palmira','Sardinal','Belén']
},
{
    'CAÑAS':
    ['Cañas','Palmira','San Miguel','Bebedero','Porozal']
},
{
    'ABANGARES':
    ['Juntas','Sierra','San Juan','Colorado']
},
{
    'TILARAN':
    ['Tilarán','Quebrada Grande','Tronadora','Santa Rosa','Líbano','Tierras Morenas','Arenal']
},
{
    'NANDAYURE':
    ['Carmona','Santa Rita','Zapotal','San Pablo','Porvenir','Bejuco']
},
{
    'LA CRUZ':
    ['La Cruz','Santa Cecilia','Garita','Santa Elena']
},
{
    'HOJANCHA':
    ['Hojancha','Monte Romo','Puerto Carrillo','Huacas']
}
]},
{
'PUNTARENAS':
[
{
    'PUNTARENAS':
    ['Puntarenas','Pitahaya','Chomes','Lepanto','Paquera','Manzanillo','Guacimal','Barranca','Monteverde','Cóbano','Chacarita','Chira','Acapulco']
},
{
    'ESPARZA':
    ['Espíritu Santo','San Juan Grande','Macacona','San Rafael','San Jerónimo']
},
{
    'BUENOS AIRES':
    ['Buenos Aires','Volcán','Potrero Grande','Boruca','Pilas','Colinas','Chánguena','Biolley']
},
{
    'MONTES DE ORO':
    ['Miramar','Unión','San Isidro']
},
{
    'OSA':
    ['Puerto Cortés','Palmar','Sierpe','Bahía Ballena','Piedras Blancas']
},
{
    'AGUIRRE':
    ['Quepos','Savegre','Naranjito']
},
{
    'GOLFITO':
    ['Golfito','Puerto Jiménez','Guaycará','Pavón']
},
{
    'COTO BRUS':
    ['San Vito','Sabalito','Agua Buena','Limoncito','Pittier']
},
{
    'PARRITA':
    ['Parrita']
},
{
    'CORREDORES':
    ['Corredor','La Cuesta','Canoas','Laurel']
},
{
    'GARABITO':
    ['Jacó','Tárcoles']
}
]},
{
'LIMON':
[
{
    'LIMON':
    ['Limón','Valle La Estrella','Río Blanco','Matama']
},
{
    'POCOCI':
    ['Guápiles','Jiménez','Rita','Roxana','Cariari','Colorado']
},
{
    'SIQUIRRES':
    ['Siquirres','Pacuarito','Florida','Germania','Cairo','Alegría']
},
{
    'TALAMANCA':
    ['Bratsi','Sixaola','Cahuita']
},
{
    'MATINA':
    ['Matina','Batán','Carrandí']
},
{
    'GUACIMO':
    ['Guácimo','Mercedes','Pocora','Río Jiménez','Duacarí']
}
]}
]

export { locations }